import { Card, Divider, Typography } from '@healthinal/ui';
import { EditPatientCategoryForm } from './EditPatientCategoryForm';
import { PatientCategory } from '../../../../../api/generated/model';

export function PatientCategoryCard({
    patientId,
    anamnesisId,
    patient,
    selectedAnamnesisType,
}: {
    patientId: string;
    anamnesisId: string;
    patient?: PatientCategory | null;
    selectedAnamnesisType: string;
}) {
    return (
        <Card>
            <Typography level="title-lg">Patientenkategorie</Typography>
            <Divider />

            <EditPatientCategoryForm
                key={anamnesisId}
                patientId={patientId}
                anamnesisId={anamnesisId}
                selectedAnamnesisType={selectedAnamnesisType}
                patient={patient}
            />
        </Card>
    );
}